
<template>
  <div id="wp-widget">
    <div v-if="control" id="whatsapp-chat">
      <div class="whatsapp-chat-header">
        <div class="whatsapp-chat-avatar">
          <img 
            src="../../assets/images/barting-coin.png"
            :alt="companyName + ' ' + 'Logo'"
          />
          <!-- <div v-else class="companyLogo"></div> -->
        </div>
        <p class="whatsapp-chat-name-block">
          <span class="whatsapp-chat-name">{{ companyName }}</span
          ><br /><small>{{ textReply }}</small>
        </p>
      </div>

      <div class="start-chat">
        <div
          pattern="https://elfsight.com/assets/chats/patterns/whatsapp.png"
          class="WhatsappChat__Component-sc-Yvjha whatsapp-chat-body"
        >
          <message-part :messages="messages" @HandelClick="HandelClick" :companyName="companyName" />
        </div>

  <div v-if="searchBox" class="blanter-msg">
          <textarea
            id="chat-input"
            placeholder="Write a response"
            maxlength="120"
            row="1"
            v-on:keyup.enter="openLink"
            v-model="text"
          ></textarea>
          <button id="send-it" @click="openLink">
            <svg viewBox="0 0 448 448">
              <path d="M.213 32L0 181.333 320 224 0 266.667.213 416 448 224z" />
            </svg>
          </button>
        </div>
      </div>
      <a class="close-chat" @click="controlHandel(false)">×</a>
    </div>
    <button
      class="blantershow-chat"
      title="Start Chat"
      @click="controlHandel"
    >
      <svg width="30"  viewBox="0 0 15 15">
        <defs />
        <path
          fill="#b88f27"
          d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"
          />
        <path
          fill="#b88f27"
         d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
        <!-- <path
          fill="#fafafa"
          d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z"
        /> -->
      </svg>
      <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-robot" viewBox="0 0 16 16">
  <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.58 26.58 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346-1.895 0-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219V8.062Zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.767 24.767 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25.286 25.286 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.182-.135Z"/>
  <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2V1.866ZM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5Z"/>
</svg> -->
    </button>
  </div>
    <ps-success-dialog ref="ps_success_dialog" />
</template>
<script>
import MessagePart from "./MessagePart.vue";
import PsSuccessDialog from '@/components/core/dialog/PsSuccessDialog.vue';
import axios from 'axios'
import { ref } from 'vue';
export default {
  components: {
    MessagePart,
    PsSuccessDialog
  },
  data() {
    return {
      control: false,
      searchBox:false,
      text: null,
      ps_success_dialog: ref(),
      messages : []
    };
  },
  props: {
    companyName: {
      type: String,
      default: "Bartin Coin",
    },
    textReply: {
      type: String,
      default: "Typically replies within an hour",
    },
    // messages: {
    //   type: Array,
    //   default: () => ["Hi there 👋 How can I help you ?"],
    // },
    companyLogo: {
      type: String,
        default: "",
    },
    phoneNumber: {
      type: String,
      default: "",
    },
  },
    mounted(){
    },
  methods: {
    controlHandel(value){
      this.messages = []
      if(value == false){
        this.control = false
        
      }else{
       this.control = this.control == true ? false : true
       if(this.control == true){
		this.polling = setInterval(() => {
      const data2 = {id:1,type:"system", text:"Hi 👋, Greetings of the day! How may I assist you ?"}
      this.messages.push(data2);
   /* eslint-disable no-mixed-spaces-and-tabs */
	    clearInterval(this.polling)
		this.polling1 = setInterval(() => {
      const data2 = {id:2,type:"system", text:"If you are a existing user than type YES.",options:['Yes','No']}
      this.messages.push(data2)
	    clearInterval(this.polling1)
		}, 2000)
		}, 1000)
		const polling1 = setInterval(() => {
       const scroll =  document.getElementById(`msg2`)
       console.log(scroll,"asd")
        scroll.scrollIntoView();
	   clearInterval(polling1)
		}, 500)
    // {id:1,type:"system", text:"Hi 👋, Greetings of the day! How may I assist you ?"},{id:2,type:"system", text:"If you are a existing user than type YES.",options:['Yes','No']}
       }
      }
      this.$forceUpdate()
    },
    HandelClick(index,id){
      this.searchBox = false 
     console.log(index,id,"jay-==-123")
     if(index == 'SignUp'){
      this.controlHandel(false)
     }
     if(id == 2){
      if(index == 0){
      const data = {id:3,type:"user", text:"Yes"}
      const data1 = {id:4,type:"system", text:"(i) If you want to check your account details kindly login with your LoginID and Password on the website with below link.",button:"Reset", text2:"(ii)If you have forgot your UserID and Password kindly enter your registered email id and click on reset.",link:"https://bartingcoin.com/login?redirect=dashboard"}
      // const data3 = {id:4,type:"system",button:"Reset"}
      this.messages.push(data)
      this.messages.push(data1)
      // this.messages.push(data3)
      const polling = window.setInterval(() => {
       const scroll =  document.getElementById(`msg4`)
       console.log(scroll,"asd")
        scroll.scrollIntoView();
        scroll.scrollIntoView(false);
	      clearInterval(polling)
      }, 500)
      }
      if(index == 1){
      const data = {id:5,type:"user", text:"No"}
      const data1 = {id:6,type:"system", text:"If you are a new user and want to generate your account kindly click on the SIGN UP",button:"SignUp"}
      const data2 = {id:7,type:"system", text:"Hope your query is been resolved.",options:['Yes','No']}
      this.messages.push(data)
      this.messages.push(data1)

      const polling1 = window.setInterval(() => {
       const scroll =  document.getElementById(`msg6`)
        scroll.scrollIntoView(false);
	      clearInterval(polling1)
        }, 300)
      const polling2 = window.setInterval(() => {
      this.messages.push(data2)
	      clearInterval(polling2)
        }, 5000)
      const polling = window.setInterval(() => {
       const scroll =  document.getElementById(`msg7`)
        scroll.scrollIntoView(false);
        scroll.scrollIntoView();
	      clearInterval(polling)
      }, 300)
      // window.setInterval(() => {
      // const data2 = {id:7,type:"system", text:"Hope your query is been resolved.",options:['Yes','No']}
      // this.messages.push(data2)
      // }, 5000)
      }
     }
     if(id == 7){
      // if(index == 0){
      const data = {id:8,type:"system", text:"Please rate this chat in 1 to 5 with below stars",rating:true}
      this.messages.push(data)
      const polling = window.setInterval(() => {
       const scroll =  document.getElementById(`msg8`)
        scroll.scrollIntoView();
        scroll.scrollIntoView(false);
	      clearInterval(polling)
      }, 500)
      // }
      // if(index == 1){

      // }
     }
     if(id == 4){
      const data = {id:9,type:"system", text:"Please Enter Your Email Address"}
      this.messages.push(data)
      const polling = window.setInterval(() => {
       const scroll1 =  document.getElementById(`msg9`)
        scroll1.scrollIntoView();
        scroll1.scrollIntoView(false);
	      clearInterval(polling)
        },300)
      this.searchBox = true
     }
     if(id == 8){
      const data = {id:11,type:"system", text:`Thanks For Giving ${index}⭐ Rating`}
      const data1 = {id:12,type:"system", text:'Chat is Closed'}
      this.messages.push(data)
      this.messages.push(data1)
      const polling = window.setInterval(() => {
       const scroll =  document.getElementById(`msg12`)
        scroll.scrollIntoView();
        scroll.scrollIntoView(false);
	      clearInterval(polling)
      }, 500)
     }
    },
    async openLink() {
      const data1 = {id:10,type:"user", text:this.text}
      this.messages.push(data1)
      const polling = window.setInterval(() => {
       const scroll1 =  document.getElementById(`msg10`)
        scroll1.scrollIntoView();
        scroll1.scrollIntoView(false);
	      clearInterval(polling)
        },300)
        const email = 
         {user_email:this.text.trim()}
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: JSON.stringify(email),
        url: 'https://crm.myproperty4u.com/webservices/bartingcoin/rest/users/reset/api_key/asdasdasdasdas',
      };
      await axios(requestOptions)
        .then((response) => {
          response.data.message == 'success_email_sent' ?  this.searchBox = false : this.searchBox = true
     
      const data = {id:10,type:"system", text:response.data.message == 'success_email_sent' ? 'Please Check Your Email' :response.data.message}
      this.messages.push(data)
      const polling = window.setInterval(() => {
       const scroll =  document.getElementById(`msg10`)
        scroll.scrollIntoView();
	      clearInterval(polling)
      }, 1000)
      if(response.data.message == 'success_email_sent'){
      const data2 = {id:7,type:"system", text:"Hope your query is been resolved.",options:['Yes','No']}
      const polling1 = window.setInterval(() => {    
        this.messages.push(data2)
	      clearInterval(polling1)
        },4000)
      const polling2 = window.setInterval(() => {
       const scroll =  document.getElementById(`msg7`)
        scroll.scrollIntoView();
	      clearInterval(polling2)
      }, 300)
        } 
        })
        .catch((error) => {this.searchBox = false ,console.log(error, "error")});
      this.text = null  
    },
  },
};
</script>
<style>
button {
  outline: none;
}
#wp-widget {
  font-family: --system-ui, "Lato", sans-serif;
  background: #f1f1f1;
}
a:link,
a:visited {
  color: #444;
  text-decoration: none;
  transition: all 0.4s ease-in-out;
}
h1 {
  font-size: 20px;
  text-align: center;
  display: block;
  background: linear-gradient(to right top, #6f96f3, #164ed2);
  padding: 20px;
  color: #fff;
  border-radius: 50px;
}
#whatsapp-chat {
  box-sizing: border-box !important;
  outline: none !important;
  position: fixed;
  width: 392px;
  border-radius: 10px;
  box-shadow: 0 1px 15px rgba(32, 33, 36, 0.28);
  bottom: 90px;
  right: 30px;
  overflow: hidden;
  z-index: 99;
  animation-name: showchat;
  animation-duration: 1s;
  transform: scale(1);
}
button.blantershow-chat {
  background: #fff;
  color: #404040;
  position: fixed;
  display: flex;
  font-weight: 400;
  justify-content: space-between;
  z-index: 98;
  bottom: 25px;
  right: 30px;
  font-size: 15px;
  padding: 15px 15px;
  border-radius: 50%;
  border: 1px solid transparent;
  box-shadow: 0 10px 10px rgba(32, 33, 36, 0.28);
  cursor: pointer;
}
button.blantershow-chat svg {
  transform: scale(1.2);
}
.whatsapp-chat-header {
  background: #0e2136;
  display: inline-flex;
  align-items: center;
  padding-left: 10px;
  height: 60px;
  width: 100%;
  height: 2cm;
  color: #fff;
}
.companyLogo {
  border-radius: 100%;
  width: 50px;
  height: 50px;
  float: left;
  margin: 0 10px 0 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.whatsapp-chat-avatar {
  position: relative;
}
.whatsapp-chat-avatar::after {
  content: "";
  bottom: 0px;
  right: 0px;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  background-color: #4ad504;
  display: block;
  position: relative;
  z-index: 1;
  border-radius: 50%;
  border: 2px solid #095e54;
  left: 40px;
  top: 38px;
}
.whatsapp-chat-avatar img {
  border-radius: 100%;
  width: 50px;
  float: left;
  margin: 0 10px 0 0;
}
.whatsapp-chat-name-block {
  text-align: left;
}
.info-chat span {
  display: block;
}
#get-label,
span.chat-label {
  font-size: 12px;
  color: #888;
}
#get-nama,
span.chat-nama {
  margin: 5px 0 0;
  font-size: 15px;
  font-weight: 700;
  color: #222;
}
#get-label,
#get-nama {
  color: #fff;
}
span.my-number {
  display: block;
}
textarea#chat-input {
  border: none;
  font-family: "Arial", sans-serif;
  width: 100%;
  outline: none;
  resize: none;
  padding: 16px;
  font-size: 14px;
}
button#send-it {
  width: 30px;
  font-weight: 700;
  border-color: transparent;
  cursor: pointer;
  background: #eee;
}
button#send-it svg {
  fill: #a6a6a6;
  height: 20px;
  width: 20px;
}
.start-chat .blanter-msg {
  display: flex;
  height: 49px;
}
a.close-chat {
  position: absolute;
  top: 5px;
  right: 15px;
  color: #fff;
  font-size: 30px;
  cursor: pointer;
}
@keyframes ZpjSY {
  0% {
    background-color: #b6b5ba;
  }
  15% {
    background-color: #111;
  }
  25% {
    background-color: #b6b5ba;
  }
}
@keyframes hPhMsj {
  15% {
    background-color: #b6b5ba;
  }
  25% {
    background-color: #111;
  }
  35% {
    background-color: #b6b5ba;
  }
}
@keyframes iUMejp {
  25% {
    background-color: #b6b5ba;
  }
  35% {
    background-color: #111;
  }
  45% {
    background-color: #b6b5ba;
  }
}
@keyframes showhidden {
  from {
    transform: scale(0.5);
    opacity: 0;
  }
}
@keyframes showchat {
  from {
    transform: scale(0);
    opacity: 0;
  }
}
@media screen and (max-width: 480px) {
  #whatsapp-chat {
    width: auto;
    left: 5%;
    right: 5%;
    font-size: 80%;
  }
}
.hidden {
  display: block;
  animation-duration: 0.5s;
  transform: scale(1);
  opacity: 1;
}
.show {
  display: block;
  animation-name: showhidden;
  animation-duration: 0.5s;
  transform: scale(1);
  opacity: 1;
}
.whatsapp-chat-body {
  padding: 20px 20px 20px 10px;
  overflow: auto;
  height: 7.5cm;
  background-color: #e6ddd4;
  position: relative;
}
.whatsapp-chat-body::before {
  display: block;
  position: absolute;
  content: "";
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
  z-index: 0;
  opacity: 0.08;
  background-color: #efe7d300;
}
.quaMo {
  z-index: 1;
}
.vzZsj {
  background-color: #fff;
  width: 52.5px;
  border-radius: 16px;
  display: flex;
  -moz-box-pack: center;
  justify-content: center;
  -moz-box-align: center;
  align-items: center;
  margin-left: 10px;
  opacity: 0;
  transition: all 0.1s ease 0s;
  z-index: 1;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
}
.Yvjha {
  position: relative;
  display: flex;
}
.ixsrax {
  height: 5px;
  width: 5px;
  margin: 0px 2px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  top: 0px;
  background-color: #9e9da2;
  animation-name: ZpjSY;
}
.dRvxoz {
  height: 5px;
  width: 5px;
  margin: 0px 2px;
  background-color: #b6b5ba;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  top: 0px;
  animation-name: hPhMsj;
}
.gjgjgjgj{
  padding: 7px 14px 6px;
  background-color: #fff;
  border-radius: 12px 0px 12px 12px;
  position: relative;
  transition: all 0.3s ease 0s;
  opacity: 0;
  transform-origin: center top 0px;
  z-index: 2;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
  margin-top: 20px;
  max-width: calc(100% - 66px);
  min-width: calc(100% - 5cm);
}
.gjgjgjgj::before {
  position: absolute;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: 14px;
  content: "";
    top: -3.5px;
    right: -14px;
    rotate: 270deg;
    width: 12px;
    height: 19px;
}
.ghvhjb{
  margin-right: 10px; 
  padding: 8px;
  border-radius: 5px;
  background-color: rgb(184 143 39);
  color: white;
  cursor: grabbing;
}
.asdfsdf{
  font-size: 14px;
  line-height: 19px;
  margin-top: 4px;
  text-align: left;
  word-break: break-word;
}
.iusdchud{
  margin-top: 15px;
  width: 100px;
}
.yughbh{
  display: flex;
  padding: 7px 14px 6px;
  background-color: #fff;
  /* border-radius: 0px 12px 12px;
  position: relative;
  transition: all 0.3s ease 0s;
  opacity: 0;
  transform-origin: center top 0px;
  z-index: 2;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
  margin-top: 20px; */
  max-width: calc(100% - 66px);
}
.kAZgZq {
  padding: 7px 14px 6px;
  background-color: #fff;
  border-radius: 0px 12px 12px;
  position: relative;
  transition: all 0.3s ease 0s;
  opacity: 0;
  transform-origin: center top 0px;
  z-index: 2;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
  margin-top: 20px;
  max-width: calc(100% - 66px);
}
.kAZgZq::before {
  position: absolute;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  top: 0px;
  left: -12px;
  width: 12px;
  height: 19px;
}
.bMIBDo {
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  color: rgba(0, 0, 0, 0.4);
}
.iSpIQi {
  font-size: 14px;
  line-height: 19px;
  margin-top: 4px;
  color: #111;
  text-align: left;
}
.cqCDVm {
  text-align: right;
  margin-top: 4px;
  font-size: 12px;
  line-height: 16px;
  color: rgba(17, 17, 17, 0.5);
  margin-right: -8px;
  margin-bottom: -4px;
}
</style>
